<app-header></app-header>

<div class="login">
  <div class="container">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="form" data-aos="zoom-in" data-aos-duration="2000">
        <h2>تسجيل الدخول</h2>
        <form [formGroup]="loginForm">
          <!-- {{ loginForm.value | json }} -->
          <div class="form-group">
            <label class="mt-5">الاسم</label>
            <input [ngClass] = "{whiteInput:userName.value.length > 0}"
              formControlName="userName"
              [class.is-invalid]="userName.invalid && userName.touched"
              type="text"
              class="form-control"
            />
            <div
              *ngIf="userName.errors && userName.invalid && userName.touched"
            >
              <small class="text-danger" *ngIf="userName.errors?.required">
                الاسم مطلوب
              </small>
              <small class="text-danger" *ngIf="userName.errors.minlength">
                لا يجب ان يقل الاسم عن 5 حروف
              </small>
              <small *ngIf="userName.errors?.forbiddenName">
                {{ userName.errors?.forbiddenName.value }} غير متاح
              </small>
            </div>
          </div>
          <div class="form-group">
            <!-- <label>Password</label> -->
            
            <label>كلمة السر</label>
            <input [ngClass] = "{whiteInput:password.value.length > 0}"
              formControlName="password"
              type="password"
              class="form-control"              
            />
          </div>
          <div *ngIf="password.errors && password.invalid && password.touched">
            <small class="text-danger" *ngIf="password.errors?.required">
              مطلوب
            </small>
            <small class="text-danger" *ngIf="password.errors.minlength">
              لا يجب ان تقل كلمة السر عن 8 حروف
            </small>
          </div>
          <small class="text-danger">{{registerError}}</small>
          <button type="submit" class="btn btn-success mt-4" (click)="submit()">
            دخول
          </button>
        </form>
      </div>     
    </div>
  </div>
</div>

<app-footer></app-footer>